import React, { useState, useEffect } from 'react';
import ThemeCard from '../ThemeCard';
// import { themes } from '../../Styles/themes';
import { premium_themes } from '../../Styles/premiumThemes';
import { useAuth } from '../../../utils/Auth';
import API from '../../../utils/API';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import './ThemeSelector.css';
import { useEnterpriseThemes, useThemes } from '../../../utils/customHooks';

// main page component
const ThemeSelector = (props) => {

    const { setStep } = props;
    const { getUpdatedUserVcard, userObj, vcardObj } = useAuth();
    const themes = useThemes(userObj);
    const enterpriseThemes = useEnterpriseThemes(userObj);
    const { custom_themes } = vcardObj;
    const { account_type } = userObj;

    const [ newThemeAllowed, setThemeAllowed ] = useState(true);
    const [ blankArray, setBlankArray ] = useState([]);
    const [ wizard ] = useState(window.location.pathname.includes('wizard'));
    const [ filteredPremiumThemes, setFilteredPremiumThemes ] = useState([]);

    // Potential fix for duplicate premium themes
    // useEffect(() => {
    //     if (userObj?.premium_themes) {
    //         Object.values(userObj?.premium_themes).forEach(({id}) => {
    //             premium_themes.forEach(theme => {
    //                 if (theme.id === id) {
    //                     setFilteredPremiumThemes(prev => (prev.find(obj => obj.id === id) ? [...prev] : [...prev, theme]))
    //                 }
    //             });
    //         });
    //     };
    // },[userObj?.premium_themes]);
    
    // creates premium theme array of available premium themes to user
    useEffect(() => {
        if (userObj?.premium_themes) {
            let newArr = [];
            Object.keys(userObj?.premium_themes).forEach(key => {
                premium_themes.forEach(theme => {
                    if (theme.id === userObj?.premium_themes[key].id) {
                        newArr.push(theme);
                    }
                });
            });
            setFilteredPremiumThemes(newArr);
        };
    },[userObj?.premium_themes]);

    // sets blank (create) themes based on current number of custom themes
    useEffect(() => {
        let themeCount = custom_themes ? custom_themes.length : 0;
        setBlankArray([]);
        for (let i = 0; i < 5-themeCount; i++) {
            setBlankArray(prev => (
                [...prev, {
                    id: 0,
                    main_background: '#dddddd',
                    profile_img_border: '#ddd',
                    top_card_color: '#ffffff',
                    top_text_color: '#444',
                    btm_card_color: '#ffffff',
                    btm_text_color: '#444',
                    icon_color: '#eee',
                    btn_color: '#eee',
                    theme_name: 'New',
                    background: "/images/blank-canvas.jpg",
                    font: "'franklin_gothic_bookregular', sans-serif",
                    type: 'custom'
                }]
            ));
        };

        if (custom_themes?.length < 5 || !custom_themes) {
            setThemeAllowed(true);
        } else {
            setThemeAllowed(false);
        };
    }, [custom_themes]);

    const selectTheme = async (theme) => {
        try {
            if (wizard) {
                const userEdit = {
                    custom_themes: [{...theme, type: 'custom', id: 0}],
                    profile_theme: {...theme, type: 'custom', id: 0},
                };

                if (custom_themes?.length > 0) {
                    userEdit?.custom_themes?.forEach(theme => {
                        if (theme.id !== userEdit.custom_themes.indexOf(theme)) {
                            theme.id = userEdit.custom_themes.indexOf(theme);
                        };
                    });
                };

                await API.updateVcardObject(userEdit);
                await getUpdatedUserVcard();
                setStep(0);
            } else {
                const userEdit = {
                    profile_theme: theme
                };

                await API.updateVcardObject(userEdit);
                await getUpdatedUserVcard();
                window.location.assign('/settings');
            };
        } catch (err) {
            console.log(err);
        };
    };

    const handleDeleteTheme = async (themeToDelete) => {

        // background to be deleted
        const backgroundToDelete = (themeToDelete.background.includes('storage.googleapis.com') && themeToDelete.background.includes(userObj?.uid)) && themeToDelete.background.split(`https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/`)[1];
        // filters custom themes to remove theme to delete
        const custom = custom_themes.filter(theme => theme !== themeToDelete);
        // maps through filter custom to find theme with ids that don't match their index and changes there id to the correct index
        custom.forEach(theme => {
            if (theme.id !== custom.indexOf(theme)) {
                theme.id = custom.indexOf(theme);
            };
        });

        let userEdit = {
            custom_themes: custom,
        };

        try {
            if (backgroundToDelete) {
                await API.deleteBackground(backgroundToDelete);
            };

            await API.updateVcardObject(userEdit);
            await getUpdatedUserVcard();
        } catch (err) {
            console.log(err);
        };
    };

    return (
        <div className='theme-selector-wrapper'>
            <div className='theme-selector-container'>
                <div className='theme-selector-title'>Theme Selector</div>
                <div className='theme-selector-subtitle'>{wizard ? 'Select from one of our wonderful designs!' : 'Select from one of our wonderful designs or create and edit your own!'}</div>
                {!wizard ?
                    <>
                    <div className='theme-selector-your'>Your Designs</div>
                    {window.innerWidth <= 600 ?
                        <Swiper
                            key={Date.now()}
                            effect={'coverflow'}
                            grabCursor={true}
                            slidesPerView={'auto'}
                            centeredSlides={true}
                            watchOverflow={true}
                            loop={true}
                            observer={true}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            pagination={true}
                            modules={[EffectCoverflow, Pagination]}
                            className='theme-selector-swiper'
                        >
                            {custom_themes?.filter(theme => theme.id === vcardObj.profile_theme.id).map(theme => (
                                <SwiperSlide key={theme.id} className='theme-selector-swiper-slide-current'>
                                    <ThemeCard theme={theme} selectTheme={selectTheme} currentTheme={true} create={false} handleDeleteTheme={handleDeleteTheme} newThemeAllowed={newThemeAllowed} />
                                </SwiperSlide>
                            ))}
                            {custom_themes?.filter(theme => theme.id !== vcardObj.profile_theme.id).map(theme => (
                                <SwiperSlide key={theme.id} className='theme-selector-swiper-slide'>
                                    <ThemeCard theme={theme} selectTheme={selectTheme} create={false} handleDeleteTheme={handleDeleteTheme} newThemeAllowed={newThemeAllowed} />
                                </SwiperSlide>
                            ))}
                            {custom_themes?.length < 5 || !custom_themes ? 
                                blankArray?.map((theme, index) => (
                                    <SwiperSlide key={index} className='theme-selector-swiper-slide'>
                                        <ThemeCard theme={theme} create={true} /> 
                                    </SwiperSlide>
                                ))
                                :
                                <></>
                            }
                        </Swiper>
                    :
                        <div className='theme-selector-themes' style={window.innerWidth <= 600 ? custom_themes ? {justifyContent: 'flex-start'} : {justifyContent: 'center'} : null}>
                            {custom_themes?.filter(theme => theme.theme_name === vcardObj.profile_theme.theme_name).map(theme => (
                                <ThemeCard theme={theme} key={theme.id} selectTheme={selectTheme} currentTheme={true} create={false} handleDeleteTheme={handleDeleteTheme} newThemeAllowed={newThemeAllowed} />
                            ))}
                            {custom_themes?.filter(theme => theme.theme_name !== vcardObj.profile_theme.theme_name).map(theme => (
                                <ThemeCard theme={theme} key={theme.id} selectTheme={selectTheme} create={false} handleDeleteTheme={handleDeleteTheme} newThemeAllowed={newThemeAllowed} />
                            ))}
                            {custom_themes?.length < 5 || !custom_themes ? 
                                blankArray?.map((theme, index) => (
                                    <ThemeCard theme={theme} key={index} create={true} /> 
                                ))
                                :
                                <></>
                            }
                        </div>
                    }
                    </>
                : <></>
                }
                {filteredPremiumThemes?.length > 0 ?
                    <>
                    <div className='theme-selector-our'>Premium Templates</div>
                    {window.innerWidth <= 600 ?
                        <Swiper
                            key={Date.now()}
                            effect={'coverflow'}
                            grabCursor={true}
                            slidesPerView={'auto'}
                            centeredSlides={true}
                            watchOverflow={true}
                            loop={filteredPremiumThemes.length > 2 ? true : false}
                            observer={true}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: false,
                            }}
                            pagination={true}
                            modules={[EffectCoverflow, Pagination]}
                            className='theme-selector-swiper'
                        >
                            {filteredPremiumThemes.map(theme => (
                                <SwiperSlide key={theme.id} className='theme-selector-swiper-slide'>
                                    <ThemeCard theme={theme} selectTheme={selectTheme} create={false} account_type={account_type} newThemeAllowed={newThemeAllowed} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    :
                        <div className='theme-selector-themes' style={{padding: '0 0 2rem 0'}}>
                            {filteredPremiumThemes.map(theme => (
                                <ThemeCard key={theme.id} theme={theme} selectTheme={selectTheme} create={false} account_type={account_type} newThemeAllowed={newThemeAllowed} />
                            ))}
                        </div>
                    }
                    </>
                    :
                    null
                }
                <div className='theme-selector-our'>Design Templates</div>
                {(window.innerWidth <= 600) ?
                    <Swiper
                        key={Date.now()}
                        effect={'coverflow'}
                        grabCursor={true}
                        slidesPerView={'auto'}
                        centeredSlides={true}
                        watchOverflow={true}
                        loop={true}
                        observer={true}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: false,
                        }}
                        pagination={true}
                        modules={[EffectCoverflow, Pagination]}
                        className='theme-selector-swiper'
                    >
                        {themes.map(theme => (
                            <SwiperSlide key={theme.id} className='theme-selector-swiper-slide'>
                                <ThemeCard theme={theme} selectTheme={selectTheme} create={false} account_type={account_type} newThemeAllowed={newThemeAllowed} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                :
                    <div className='theme-selector-themes'>
                        {themes.map(theme => (
                            <ThemeCard key={theme.id} theme={theme} selectTheme={selectTheme} create={false} account_type={account_type} newThemeAllowed={newThemeAllowed} />
                        ))}
                    </div>
                }
            </div>
        </div>
    );
};

export default ThemeSelector;